angular.module('unica_media_directory.media_directory_controllers')

.controller('MediaDirectoryCreateController', function(
	$rootScope, $scope, $state, $stateParams,
	MediaDirectoryCreateService
) {

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getEventStages( $stateParams.event_id );


	$scope.pageTitle = 'Aggiungi Directory';

	$rootScope.mediaDirectoryData = {
		event_id: $stateParams.event_id,
		title: ''
	};

	$scope.saveMediaDirectory = function() {
		$scope.showLoader();

		var mediaDirectoryData = angular.copy($rootScope.mediaDirectoryData);

		MediaDirectoryCreateService
			.create(mediaDirectoryData)
			.then(function(data) {
				$scope.hideLoader();
				if (!data.error) {
					$scope.showSuccessMsg('Media Directory aggiunta con successo!', '');
					$state.go('app.media_directory.list', { event_id: $stateParams.event_id });
				} else {
					$rootScope.manageError(data);
				}
			});
	};

})

;